import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ContentHostDirective } from './content-host.component';

@Component({
  templateUrl: './bookmark-nav.component.html',
  styleUrls: ['./bookmark-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookmarkNavComponent implements OnDestroy, OnInit {
  @ViewChild(ContentHostDirective, { static: true }) contentHost: ContentHostDirective;

  routeDataSub: Subscription;
  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.routeDataSub = this.route.data.subscribe(v => {
      if (v.component) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(v.component);

        const viewContainerRef = this.contentHost.viewContainerRef;
        viewContainerRef.clear();

        const componentRef = viewContainerRef.createComponent(componentFactory);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routeDataSub) {
      this.routeDataSub.unsubscribe();
    }
  }
}
